<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col col-1" v-if="isMobile() === false">
      </div>
      <div class="col">
        <div class="row bg-secondary text-bg-secondary fw-bold p-2 mb-3 rounded">
          <div class="col">
            <BreadcrumbTheme v-if="selectedView === 'theme'"/>
            <BreadcrumbSession v-if="selectedView === 'session'"/>
            <div v-if="selectedView === 'author'">{{authorList[selectedAuthor].lastname}}, {{authorList[selectedAuthor].firstname}}</div>
          </div>
        </div>
        <div v-if="!loader && filteredPosters">
          <div class="row" v-if="selectedView === 'search' && selectedSearch.length === 0">
            <div class="col">
              <div class="alert alert-warning fw-bold row">
                <div class="col-1">
                  <icon :icon="['fal', 'triangle-exclamation']" class="fa-3x"/>
                </div>
                <div class="col my-auto">
                  Sorry, your search did not return any results.<br>
                  We show you all posters instead.
                </div>
              </div>
            </div>
          </div>
          <div class="row row-cols-1 row-cols-md-3 row-cols-lg-3 g-3">
            <div class="col"
                 v-for="poster in filteredPosters">
              <Card :poster="poster"/>
            </div>

          </div>
        </div>
        <Loader v-else></Loader>
      </div>
      <div class="col col-1" v-if="isMobile() === false"></div>
    </div>
    <div class="fixed-bottom d-flex">
      <a href="#" v-scroll-to="'#top'" class="ms-auto me-4 mb-4" title="Scroll to top">
        <icon :icon="['fad', 'arrow-circle-up']" class="fa-2x text-primary"/>
      </a>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapMutations, mapState} from 'vuex'
import Card from "../components/items/Card";
import BreadcrumbTheme from "../components/breadcrumbs/BreadcrumbTheme";
import BreadcrumbSession from "../components/breadcrumbs/BreadcrumbSession";
import Loader from "../components/Loader";

const VueScrollTo = require('vue-scrollto');
export default {
  data: function () {
    return {
      search: '',
    }
  },
  components: {
    Loader,
    BreadcrumbSession,
    BreadcrumbTheme,
    Card
  },
  computed: {
    ...mapState([
      'posters', 'mode', 'fullscreen', 'loader', 'themes', 'datahelper', 'ratings', 'selectedView', 'selectedSearch'
    ]),
    ...mapState('theme', ['firstLevelTheme', 'secondLevelTheme', 'selectedTheme']),
    ...mapState('author', ['authorList', 'selectedAuthor']),
    ...mapGetters([
      'filteredPosters',
    ]),
    selectedThemeComp: {
      get() {
        return this.selectedTheme
      },
      set(id) {
        this.setSelectedTheme(id);
      }
    }
  },
  methods: {
    ...mapMutations('theme', ['setFirstLevelTheme', 'setSecondLevelTheme', 'setSelectedTheme']),
    getImgUrl(src) {
      return process.env.VUE_APP_PATH_FILESERVERURL + src + '/resize/' + process.env.VUE_APP_THUMBNAIL_WIDTH + '/' + process.env.VUE_APP_THUMBNAIL_HEIGHT;
      // return process.env.VUE_APP_PATH_S3URL + src + '-' + process.env.VUE_APP_THUMBNAIL_WIDTH + '-' + process.env.VUE_APP_THUMBNAIL_HEIGHT + '-1-undefined-image';
    },
    setMode(mode) {
      this.$store.state.mode.displayType = mode;
    },
    doSearch() {
      this.$store.state.loader = true;
      this.$store.dispatch('GET_ALL_RATINGS');
      if (this.search.length > 0) {
        let searchObject = {search: this.search, mode: this.$store.state.mode}
        this.$store.dispatch('GET_POSTERS', searchObject);
      } else {
        this.$store.dispatch('GET_ALL_POSTERS', this.$store.state.mode);
      }
    },
    resetSearch() {
      this.search = '';
      this.doSearch();
    },
    selectOption() {
    }
  },
  created() {
    this.$store.state.fullscreen = false;
    this.$store.state.presentationSite = null;
  }
}
</script>

